import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "location-selector" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("h2", null, "What services do you need?", -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("p", { class: "mb-4" }, " To get started, please provide your location. We will reach out to participating automotive service professionals near you and deliver price estimates for the service you are requesting. ", -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_LocationSearch = _resolveComponent("LocationSearch")!

  return (_openBlock(), _createElementBlock("section", _hoisted_1, [
    _hoisted_2,
    _hoisted_3,
    _createVNode(_component_LocationSearch, {
      "hide-sub-text": "",
      onSelectLocation: _ctx.checkCoverage
    }, null, 8, ["onSelectLocation"])
  ]))
}